// extracted by mini-css-extract-plugin
module.exports = {"base":"base--VzZlte","error":"error--u0Ektk"};